import getCombatantIndexById from "./getCombatantIndexById";
import setBlankCR from "./setBlankCR";
import store from "../store/index";
//----------------
// fill blank crs
//----------------
export default function fillBlankCRs(parm) {
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  let maxCR = this_store.config.max_cr;
  //-------------------
  // get combatant idx
  //-------------------
  let i = getCombatantIndexById(parm.id);
  //----------
  // set vars
  //----------
  let slots_used = combatants[i].reaction_count;
  let combatant_cr = combatants[i].cr;
  let blanks = maxCR - combatant_cr - slots_used;
  let from_slot = maxCR - blanks + 1;
  //------------------------------------------------------------------
  // loop from slot next to where reaction changed -> possible max cr
  //------------------------------------------------------------------
  for (let k = from_slot; k <= maxCR; k++) {
    //---------------
    // set slot parm
    //---------------
    let slot_parm = {
      id: parm.id,
      cr_num: k,
    };
    setBlankCR(slot_parm);
  }
}
